// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';


var Search = /* module */[
  /* appId */"B1AVN0IGTU",
  /* apiKey */"c7a3475a8567971cb7510b422d9f37ad",
  /* packageIndex */"redex-packages"
];

function titleTemplate(title) {
  return "" + (String(title) + " | redex");
}

exports.Search = Search;
exports.titleTemplate = titleTemplate;
/* No side effect */



// WEBPACK FOOTER //
// ./src/Config.js